import * as dd from "dingtalk-jsapi";
import store from '../store'
import router from '../router'
import request from '@/utils/request'
import { getStorage, removeToken, removeStorage } from '@/utils/auth'
import { Message } from 'element-ui';
import qs from "qs";

export function isInDingTalk() {
  return dd.env.platform !== 'notInDingTalk';
}

function applyLoginResult(res, authed, cb) {
  if (!res.success || !res.data) {
    return;
  }
  store.commit("user/SET_USERID", res.data.userId);
  store.commit("user/SET_TOKEN", res.data.token);
  if (!authed) {
    store.commit("user/SET_MENULIST", res.data.permission);
    store.dispatch('user/changeMenus')
  }
  if (res.data.name) {
    store.commit("demo/SET_USERINFO", {
      ...(store.getters.userInfo || {}),
      id: res.data.userId,
      name: res.data.name,
    });
  }
  request.get('/api/user/' + res.data.userId).then((userRes) => {
    if (userRes.success && userRes.data) {
      store.commit("demo/SET_USERINFO", userRes.data);
    }
    if (cb) {
      cb();
    }
  }).catch(() => {
    if (cb) {
      cb();
    }
  });
}

export function loginByDingTalk(cb, authed) {
  try {
    dd.ready(function () {
      try {
        dd.runtime.permission.requestAuthCode({
          corpId: getStorage('corpId'),
          onSuccess: function (result) {
            var params = qs.stringify({
              authCode: result.code
            });
            request
              .post("/login?" + params)
              .then((res) => {
                if (res.success) {
                  applyLoginResult(res, authed, cb);
                }
              });
          },
          onFail: function () {
            Message({ type: "warning", message: "钉钉登录失败" });
            if (cb) {
              cb();
            }
          },
        });
      } catch (e) {
        alert(e);
        if (cb) {
          cb();
        }
      }
    });
  } catch (e) {
    if (cb) {
      cb();
    }
  }
}

export function clearLoginState() {
  removeToken();
  removeStorage('userId');
  store.commit("user/SET_USERID", '');
  store.commit("user/SET_TOKEN", '');
  store.commit("demo/SET_USERINFO", {});
}

export function goPasswordLogin(redirect) {
  clearLoginState();
  const query = redirect ? { redirect } : {};
  if (router.currentRoute.path !== '/login') {
    router.replace({ path: '/login', query });
  }
}

export function reLogin(cb) {
  if (isInDingTalk()) {
    loginByDingTalk(cb, true);
  } else {
    goPasswordLogin(router.currentRoute.fullPath);
    if (cb) {
      cb();
    }
  }
}
